import {Injectable} from "@angular/core";
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {BehaviorSubject, Observable, throwError} from "rxjs";
import {catchError, filter, switchMap, take} from "rxjs/operators";
import {TokenStore} from "../shared/services/token.store";
import {Router} from "@angular/router";
import {AuthService} from "./auth.service";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  refreshInProgress = false;
  refreshed$: BehaviorSubject<string> = new BehaviorSubject('');


  constructor(
    private token: TokenStore,
    private router: Router,
    private auth: AuthService,
  ) {
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add authorization header with jwt token if available
    const jwt = JSON.parse(localStorage.getItem('jwt') || '{}');
    if (jwt) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt.token}`
        }
      });
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // handle expired token
        if (error.status === 401 && !request.url.includes('/api/login_check')) {
          if (this.refreshInProgress) {
            return this.refreshed$.pipe(
              filter(token => token !== null),
              take(1),
              switchMap((token) => next.handle(this.addAuthHeader(request, token)))
            );
          }

          this.refreshInProgress = true;
          this.refreshed$.next('');

          return this.auth.refresh({refresh_token: this.token.getRefresh()})
            .pipe(
              switchMap((response) => {
                this.token.save(response.token, response.refresh_token);
                this.refreshInProgress = false;
                this.refreshed$.next(response.token);
                return next.handle(this.addAuthHeader(request, response.token));
              }),
              catchError(error => {
                this.token.clear();
                this.router.navigate(['/login']);
                this.refreshInProgress = false;
                return throwError(error);
              }),
            );
        }

        return throwError(error);
      })
    )
  }

  addAuthHeader(
    request: HttpRequest<any>,
    token: string
  ): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      }
    })
  }
}
